// The matching rule for "a note on this record changed" — kept in its
// own DOM-free file.
//
// Split from notes-changed-event.ts deliberately: that file touches
// `window`, and this rule is unit-tested from tests/, which the root
// tsconfig type-checks with Workers types (no DOM lib). Importing the
// event module from a test would fail on `window` not existing there.
// The rule is the part worth testing anyway; the dispatch around it is
// three lines of standard DOM.

export interface NotesChangedDetail {
  /** `notes.entity_type` — the record the note lives on. */
  entityType: string;
  entityId: string;
}

/**
 * Does a change on `changed` concern the record `watching` is showing?
 *
 * BOTH halves have to match. Every record kind shares one id space, so
 * matching on id alone would refetch the wrong page.
 */
export function notesChangeMatches(
  watching: NotesChangedDetail,
  changed: NotesChangedDetail | undefined | null,
): boolean {
  if (!changed) return false;
  return changed.entityType === watching.entityType && changed.entityId === watching.entityId;
}
